const strftime = require('strftime');
export default class ScheduleTick {
	static get TERM() {
		const TERM = {
			AM: '0',
			PM: '1',
		};
		return TERM;
	}

	static msecToDays(msec) {
		return Math.floor(msec/(1000 * 60 * 60 * 24));
	}

	static msecToTicks(msec) {
		return Math.floor(msec/(1000 * 60 * 60 * 12));
	}

	get date() {
		let date = new Date(String(this.code).substr(0, 4) + '/' + String(this.code).substr(4, 2) + '/' + String(this.code).substr(6, 2));
		if (this.term === ScheduleTick.TERM.PM)
			date.setTime(date.getTime() + 12 * 60 * 60 * 1000);

		return date;
	}
	get term() {
		return String(this.code).substr(8, 1);
	}

	get prevTickCode() {
		if (this.term == ScheduleTick.TERM.PM)
			return String(this.code).substr(0, 8) + ScheduleTick.TERM.AM;
		
		let date = this.date;
		date.setDate(date.getDate() - 1);
		return strftime("%Y%m%d", date) + ScheduleTick.TERM.PM;
	}
	get nextTickCode() {
		if (this.term == ScheduleTick.TERM.AM)
			return String(this.code).substr(0, 8) + ScheduleTick.TERM.PM;
		
		let date = this.date;
		date.setDate(date.getDate() + 1);
		return strftime("%Y%m%d", date) + ScheduleTick.TERM.AM;
	}
	
	constructor(params) {
		this.code = params.code;
	}
	
	offsetDays(base_date) {
		return ScheduleTick.msecToDays(this.date.getTime() - base_date.getTime());
	}

	offsetTicks(base_date) {
		return ScheduleTick.msecToTicks(this.date.getTime() - base_date.getTime());
	}

	addTick(ticks) {
		let days = Math.trunc(ticks / 2);
		let remain = ticks % 2;
		let term = this.term;

		if (remain != 0) {
			switch (term) {
			case ScheduleTick.TERM.AM: 
				if (remain < 0)
					days += remain;
				term = ScheduleTick.TERM.PM;
				break;
			case ScheduleTick.TERM.PM: 
				if (0 < remain)
					days += remain;
				term = ScheduleTick.TERM.AM;
				break;
			}
		}

		let date = this.date;
		date.setDate(date.getDate() + days);

		this.code = parseInt(strftime('%Y%m%d', date) + term);
		return this;
	}
	
	clone() {
		return new ScheduleTick({
			code: this.code,
		});
	}
}
